import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './styles.css';

function RankingCard({ title, data, type, headerColor = 'primary' }) {
  const renderRankingItem = (item, index) => {
    const position = index + 1;
    const getBadgeVariant = (pos) => {
      if (pos === 1) return 'success'; // Green
      if (pos === 2) return 'success'; // Green
      if (pos === 3) return 'success'; // Green
      return 'success';
    };

    return (
      <div key={index} className="ranking-item d-flex align-items-center mb-2">
        <Badge bg={getBadgeVariant(position)} className="ranking-position me-3">
          {position}º
        </Badge>
        <div className="flex-grow-1">
          <div className="ranking-name">
            {type === 'attendant' ? item.name : item.customerName}
          </div>
          {type === 'attendant' && item.department && (
            <small className="text-muted">{item.department}</small>
          )}
        </div>
        <div className="ranking-count">
          <strong className="text-success">{item.count}</strong>
          <small className="text-muted d-block">
            {type === 'attendant' ? 'tickets' : 'chamados'}
          </small>
        </div>
      </div>
    );
  };

  return (
    <Card className="ranking-card h-100">
      <Card.Header className={`bg-${headerColor} text-white`}>
        <h6 className="mb-0">{title}</h6>
      </Card.Header>
      <Card.Body>
        {data && data.length > 0 ? (
          <div className="ranking-list">
            {data.map((item, index) => renderRankingItem(item, index))}
          </div>
        ) : (
          <div className="text-center text-muted py-4">
            <i className="fas fa-chart-bar fa-2x mb-2" />
            <p>Nenhum dado disponível</p>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

RankingCard.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      customerName: PropTypes.string,
      department: PropTypes.string,
      count: PropTypes.number.isRequired,
    })
  ),
  type: PropTypes.oneOf(['attendant', 'customer']),
  headerColor: PropTypes.string,
};

RankingCard.defaultProps = {
  data: [],
  type: 'attendant',
  headerColor: 'primary',
};

export default RankingCard;
